import {RegisterType} from 'app/components/sign/registration/registerType';

export const registerModalPropsResolver = () => {
    const search = window.location.search;

    return {
        tab: /business/.test(search) ? RegisterType.INDIVIDUAL : RegisterType.INDIVIDUAL,
    }
};